import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import AppAside from "@/layout/AppAside.vue";
Vue.use(VueRouter);
Vue.component("AppAside", AppAside);
import notfound from "@/views/not_found.vue";

const login = () => import("@/views/login.vue");
const signup = () => import("@/views/signup.vue");

const SuppSections = () => import("@/views/superadmin/SupplierSections.vue");
const suppliers = () => import("@/views/superadmin/Suppliers.vue");
const translations = () => import("@/views/superadmin/Translations.vue");
const languages = () => import("@/views/superadmin/Languages.vue");
const customers = () => import("@/views/superadmin/Customers.vue");

const BusinessTypes = () => import("@/views/superadmin/BusinessTypes.vue");
const cities = () => import("@/views/superadmin/Cities.vue");
const IntroPages = () => import("@/views/superadmin/IntroPages.vue");

//--------------------- End Admin Routes

const dashboard = () => import("@/views/Supplier/Dashboard");

const ClosedOrders = () => import("@/views/Supplier/Orders/ClosedOrders");
const Orders = () => import("@/views/Supplier/Orders/Orders");
const OrdersProducts = () => import("@/views/Supplier/Orders/OrdersProducts");
const Order = () => import("@/views/Supplier/Orders/Order");
const OrdersTable = () => import("@/views/Supplier/Orders/OrdersTable");
const OrderAdd = () => import("@/views/Supplier/Orders/OrderAdd");
const OrdersLogs = () => import("@/views/Supplier/Orders/OrdersLogs");
const OrdersActivities = () =>
  import("@/views/Supplier/Orders/OrdersActivities");

const Compensations = () =>
  import("@/views/Supplier/Compensations/Compensations");
const CompensationsTable = () => import("@/views/Supplier/Compensations/Table");
const Compensation = () =>
  import("@/views/Supplier/Compensations/Compensation");
const AddCompensation = () =>
  import("@/views/Supplier/Compensations/AddCompensation");

const categories = () => import("@/views/Supplier/Categories/Categories");
const CatTable = () => import("@/views/Supplier/Categories/CatTable");
const CatForm = () => import("@/views/Supplier/Categories/CatForm");

const coupons = () => import("@/views/Supplier/Coupons/Coupons");
const CouponTable = () => import("@/views/Supplier/Coupons/CouponTable");
const CouponForm = () => import("@/views/Supplier/Coupons/CouponForm");

const Payments = () => import("@/views/Supplier/Payments/Payments");
const PayTable = () => import("@/views/Supplier/Payments/PayTable");
const PayForm = () => import("@/views/Supplier/Payments/PayForm");
const ChecksTable = () => import("@/views/Supplier/Payments/ChecksTable");

const banners = () => import("@/views/Supplier/Banners/Banners");
const BannerTable = () => import("@/views/Supplier/Banners/BannerTable");
const BannerForm = () => import("@/views/Supplier/Banners/BannerForm");

const Boxes = () => import("@/views/Supplier/Boxes/Boxes");
const BoxesTable = () => import("@/views/Supplier/Boxes/BoxesTable");
const BoxForm = () => import("@/views/Supplier/Boxes/BoxForm");

const Employee = () => import("@/views/Supplier/Employee/Employee");
const EmployeeTable = () => import("@/views/Supplier/Employee/EmployeeTable");
const EmployeeForm = () => import("@/views/Supplier/Employee/EmployeeForm");
const AddEmployee = () => import("@/views/Supplier/Employee/AddEmployee");

const Brands = () => import("@/views/Supplier/Brands/Brands");
const BrandsForm = () => import("@/views/Supplier/Brands/BrandsForm");
const BrandsTable = () => import("@/views/Supplier/Brands/BrandsTable");

const Products = () => import("@/views/Supplier/Products/Products");
const ProductsForm = () => import("@/views/Supplier/Products/ProductsForm");
const ProductsTable = () => import("@/views/Supplier/Products/ProductsTable");

const supp_customers = () => import("@/views/Supplier/Customers/Customers");
const CustomersTable = () =>
  import("@/views/Supplier/Customers/CustomersTable");
const AddCustomer = () => import("@/views/Supplier/Customers/AddCustomer");
const CustomerForm = () => import("@/views/Supplier/Customers/CustomerForm");
const Customer = () => import("@/views/Supplier/Customers/Customer");

const Prices = () => import("@/views/Supplier/Prices/Prices");
const PricesTable = () => import("@/views/Supplier/Prices/PricesTable");
const PriceForm = () => import("@/views/Supplier/Prices/PriceForm");

const OwnCities = () => import("@/views/Supplier/OwnCities/OwnCities");
const OwnCitiesForm = () => import("@/views/Supplier/OwnCities/OwnCitiesForm");

const Settings = () => import("@/views/Supplier/Settings/settings");
const SettingsNav = () => import("@/views/Supplier/Settings/SettingsNav");
const GeneralSettings = () =>
  import("@/views/Supplier/Settings/GeneralSettings");

const routes = [
  {
    path: "/cities",
    name: "cities",
    component: cities,
    meta: {
      title: "cities",
      requiresAuth: true,
      super_admin: true,
    },
  },
  {
    path: "/languages",
    name: "languages",
    component: languages,
    meta: {
      title: "languages",
      requiresAuth: true,
      super_admin: true,
    },
  },
  {
    path: "/translations",
    name: "translations",
    component: translations,
    meta: {
      title: "translations",
      requiresAuth: true,
      super_admin: true,
    },
  },
  {
    path: "/suppliers",
    name: "suppliers",
    component: suppliers,
    meta: {
      title: "suppliers",
      requiresAuth: true,
      super_admin: true,
    },
  },
  {
    path: "/suppSections",
    name: "suppSections",
    component: SuppSections,
    meta: {
      title: "suppSections",
      requiresAuth: true,
      super_admin: true,
    },
  },
  {
    path: "/s_customers",
    name: "c_customers",
    component: customers,
    meta: {
      title: "customers",
      requiresAuth: true,
      super_admin: true,
    },
  },

  {
    path: "/businessTypes",
    name: "businessTypes",
    component: BusinessTypes,
    meta: {
      title: "BusinessTypes",
      requiresAuth: true,
      super_admin: true,
    },
  },
  {
    path: "/introPages",
    name: "introPages",
    component: IntroPages,
    meta: {
      title: "introPages",
      requiresAuth: true,
      super_admin: true,
    },
  },

  /* --------------------- 
  ------------------------------------------------
  End Admin Routes
  ------------------------------------------------
  */
  {
    path: "/dashboard",
    component: dashboard,
    name: "dashboard",
    meta: {
      title: "dashboard",
      requiresAuth: true,
      super_admin: false,
      permission: "dashboard access",
    },
  },

  {
    path: "/ordersActivities",
    component: OrdersActivities,
    name: "ordersActivities",
    meta: {
      title: "OrdersActivities",
      requiresAuth: true,
      super_admin: false,
      noMenu: true,
      permission: "orders edit",
    },
  },
  {
    path: "/orders",
    component: Orders,
    meta: {
      title: "Orders",
      requiresAuth: true,
      super_admin: false,
      permission: "orders access",
    },
    children: [
      {
        path: "/",
        name: "orders",
        component: OrdersTable,

        meta: {
          title: "Orders",
          requiresAuth: true,
          super_admin: false,
          permission: "orders access",
        },
      },
      {
        path: "order/:id",
        name: "Order",
        component: Order,
        meta: {
          title: "Order",
          requiresAuth: true,
          super_admin: false,
          permission: "orders access",
        },
      },
      {
        path: "add/:id?",
        name: "addOrder",
        component: OrderAdd,
        meta: {
          title: "addOrder",
          requiresAuth: true,
          super_admin: false,
          permission: "orders create",
        },
      },
      {
        path: "products",
        name: "order_products",
        component: OrdersProducts,
        meta: {
          title: "order_products",
          requiresAuth: true,
          super_admin: false,
          permission: "orders access",
        },
      },

      {
        path: "closed",
        component: ClosedOrders,
        name: "closedOrders",
        meta: {
          title: "closedOrders",
          requiresAuth: true,
          super_admin: false,
          permission: "orders access",
        },
      },
    ],
  },
  {
    path: "/compensations",
    component: Compensations,
    meta: {
      title: "Compensations",
      requiresAuth: true,
      super_admin: false,
      permission: "orders access",
    },
    children: [
      {
        path: "/",
        name: "compensations",
        component: CompensationsTable,

        meta: {
          title: "compensations",
          requiresAuth: true,
          super_admin: false,
          permission: "orders access",
        },
      },
      {
        path: ":id",
        name: "compensation",
        component: Compensation,
        meta: {
          title: "compensation",
          requiresAuth: true,
          super_admin: false,
          permission: "orders access",
        },
      },
      {
        path: "add/:id",
        name: "addCompensation",
        component: AddCompensation,
        meta: {
          title: "AddCompensation",
          requiresAuth: true,
          super_admin: false,
          permission: "orders access",
        },
      },
    ],
  },

  {
    path: "/OrdersLogs",
    name: "ordersLogs",
    component: OrdersLogs,
    meta: {
      title: "OrdersLogs",
      requiresAuth: true,
      super_admin: false,
      permission: "orders logs",
    },
  },

  {
    path: "/categories",
    component: categories,

    children: [
      {
        meta: {
          title: "categories",
          requiresAuth: true,
          super_admin: false,
          permission: "categories access",
        },
        path: "/",
        name: "categories",
        component: CatTable,
      },
      {
        path: "form/:id?",
        name: "CatForm",
        component: CatForm,
        meta: {
          title: "categories",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "categories create",
          editPermission: "categories edit",
        },
      },
    ],
  },

  {
    path: "/coupons",
    component: coupons,
    meta: {
      title: "coupons",
      requiresAuth: true,
      super_admin: false,
      permission: "coupons access",
    },
    children: [
      {
        path: "/",
        name: "coupons",
        component: CouponTable,
        meta: {
          requiresAuth: true,
          super_admin: false,
          title: "coupons",
          permission: "coupons access",
        },
      },
      {
        path: "form/:id?",
        name: "CouponForm",
        component: CouponForm,
        meta: {
          title: "coupon",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "coupons create",
          editPermission: "coupons edit",
        },
      },
    ],
  },

  {
    path: "/payments",
    component: Payments,
    meta: {
      title: "payments",
      requiresAuth: true,
      super_admin: false,
      permission: "coupons access",
    },
    children: [
      {
        path: "/",
        name: "payments",
        component: PayTable,
        meta: {
          requiresAuth: true,
          super_admin: false,
          permission: "coupons access",
          title: "payments",
          permission: "coupons access",
        },
      },

      {
        path: "form/:id?",
        name: "PayForm",
        component: PayForm,
        meta: {
          title: "payment",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "payments create",
          editPermission: "payments edit",
        },
      },
      {
        path: "checks",
        name: "checks",
        component: ChecksTable,
        meta: {
          title: "checks",
          requiresAuth: true,
          super_admin: false,
          permission: "checks access",
        },
      },
    ],
  },

  {
    path: "/banners",
    component: banners,

    children: [
      {
        path: "/",
        name: "banners",
        component: BannerTable,
        meta: {
          title: "banners",
          requiresAuth: true,
          super_admin: false,
          permission: "banners access",
        },
      },
      {
        path: "form/:id?",
        name: "BannerForm",
        component: BannerForm,
        meta: {
          title: "banners",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "banners create",
          editPermission: "banners edit",
        },
      },
    ],
  },

  {
    path: "/boxes",
    component: Boxes,

    children: [
      {
        path: "/",
        name: "boxes",
        component: BoxesTable,
        meta: {
          title: "boxes",
          requiresAuth: true,
          super_admin: false,
          permission: "boxes access",
        },
      },
      {
        path: "form/:id?",
        name: "boxForm",
        component: BoxForm,
        meta: {
          title: "boxes",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "boxes create",
          editPermission: "boxes edit",
        },
      },
    ],
  },

  {
    path: "/employees",
    component: Employee,

    children: [
      {
        path: "/",
        name: "employees",
        component: EmployeeTable,
        meta: {
          title: "Employee",
          requiresAuth: true,
          super_admin: false,
          permission: "employees access",
        },
      },
      {
        path: "form/:id",
        name: "EmployeeForm",
        component: EmployeeForm,
        meta: {
          title: "employees",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "employees create",
          editPermission: "employees edit",
        },
      },
      {
        path: "add",
        name: "addEmployee",
        component: AddEmployee,
        meta: {
          title: "employees",
          requiresAuth: true,
          super_admin: false,
          permission: "employees create",
        },
      },
    ],
  },
  {
    path: "/brands",
    component: Brands,
    children: [
      {
        path: "/",
        name: "brands",
        component: BrandsTable,
        meta: {
          title: "brands",
          requiresAuth: true,
          super_admin: false,
          permission: "brands access",
        },
      },
      {
        path: "form/:id?",
        name: "BrandForm",
        component: BrandsForm,
        meta: {
          title: "brands",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "brands create",
          editPermission: "brands edit",
        },
      },
    ],
  },

  {
    path: "/products",
    component: Products,
    meta: {
      title: "products",
      requiresAuth: true,
      super_admin: false,
      permission: "products access",
    },
    children: [
      {
        path: "/",
        name: "products",
        component: ProductsTable,
        meta: {
          title: "products",
          requiresAuth: true,
          super_admin: false,
          permission: "products access",
        },
      },
      {
        path: "form/:id?",
        name: "ProductsForm",
        component: ProductsForm,
        meta: {
          title: "products",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "products create",
          editPermission: "products edit",
        },
      },
    ],
  },

  {
    path: "/customers",
    component: supp_customers,
    children: [
      {
        path: "/",
        name: "customers",
        component: CustomersTable,
        meta: {
          title: "customers",
          requiresAuth: true,
          super_admin: false,
          permission: "customers access",
        },
      },
      {
        path: "profile/:id",
        name: "customer",
        component: Customer,
        meta: {
          title: "Customer",
          requiresAuth: true,
          super_admin: false,
          permission: "customers access",
        },
      },
      {
        path: "add",
        name: "add",
        component: AddCustomer,
        meta: {
          title: "customers",
          requiresAuth: true,
          super_admin: false,
          permission: "customers create",
        },
      },
      {
        path: "form/:id?",
        name: "supp_customer_form",
        component: CustomerForm,
        meta: {
          title: "customers",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "customers create",
          editPermission: "customers edit",
        },
      },
    ],
  },

  {
    path: "/prices",
    component: Prices,

    children: [
      {
        path: "/",
        name: "prices",
        component: PricesTable,
        meta: {
          title: "Prices",
          requiresAuth: true,
          super_admin: false,
          permission: "prices access",
        },
      },
      {
        path: "form/:id?",
        name: "priceForm",
        component: PriceForm,
        meta: {
          title: "prices",
          requiresAuth: true,
          super_admin: false,
          is_form: true,
          createPermission: "prices create",
          editPermission: "prices edit",
        },
      },
    ],
  },

  {
    path: "/own_cities",
    component: OwnCities,
    meta: {
      title: "OwnCities",
      requiresAuth: true,
      super_admin: false,
      permission: "cities access",
    },
    children: [
      {
        path: "/",
        name: "ownCities",
        component: OwnCitiesForm,
        meta: {
          title: "OwnCities",
          requiresAuth: true,
          super_admin: false,
          permission: "cities access",
        },
      },
    ],
  },

  {
    path: "/settings",
    component: Settings,

    children: [
      {
        path: "/",
        name: "SettingsNav",
        component: SettingsNav,
        meta: {
          title: "settings",
          requiresAuth: true,
          super_admin: false,
          permission: "settings access",
        },
      },

      {
        path: "general",
        name: "general",
        component: GeneralSettings,
        meta: {
          title: "general",
          requiresAuth: true,
          super_admin: false,
          permission: "settings access",
        },
      },
    ],
  },
  {
    path: "/signup",
    name: "signup",
    component: signup,
    meta: {
      title: "signup",
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "login",
    component: login,
    meta: {
      title: "login",
      requiresAuth: false,
    },
  },

  {
    path: "*",
    name: "problem",
    component: notfound,
    meta: {
      title: "notfound",
      requiresAuth: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || "Default Title";
  const isSupp = store.getters.isSupp;
  // Check if data fetching is needed before routing

  if (!store.state.langs.length && store.getters.loggedin && isSupp) {
    await store.dispatch("get_requirements");
  } else if (!store.state.langs.length && !isSupp && store.getters.loggedin) {
    store.dispatch("get_langs");
  }

  const userPermissions = store.state.userPermissions;
  const isLoggedIn = store.getters.loggedin;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isSuperAdminRoute = to.meta.super_admin;

  const hasPermission = (permission) => userPermissions.includes(permission);
  if (to.name === "notfound") {
    return next();
  }

  if (!requiresAuth) {
    if (to.name === "login") {
      if (isSupp && isLoggedIn) {
        return next("orders");
      } else if (!isSupp && isLoggedIn) {
        return next("suppliers");
      }
    }
    return next();
  }

  if (!isLoggedIn) {
    return next({ name: "login" });
  }

  if (!isSupp) {
    if (isSuperAdminRoute) {
      return next();
    }
    return next("suppliers");
  }

  if (!isSuperAdminRoute) {
    if (!to.meta.is_form && hasPermission(to.meta.permission)) {
      return next();
    } else if (!to.meta.is_form && hasPermission(to.meta.createPermission)) {
      return next();
    } else if (
      to.meta.is_form &&
      Object.values(to.params).filter((e) => !!e).length &&
      hasPermission(to.meta.editPermission)
    ) {
      return next();
    } else if (to.meta.is_form && hasPermission(to.meta.createPermission)) {
      return next();
    }
    return next({ name: "problem" });
  }

  if (to.name === "login") {
    return next(isSupp ? "dashboard" : "suppliers");
  }

  next();
});

export default router;
